export default "/_next/static/images/2c167e640d4d60bf04d64d032a3b8a39.png";